import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../library/button/button';

import { useModal } from '../../shared/hooks/hooks';

import * as MODAL_TYPES from '../../shared/constants/modals';

import './check-inventory-button.scss';

function CheckInventoryButton(props) {
  const {
    className,
    hideCartItems,
    initialQuantity,
    initialRearQuantity,
    onCheckInventoryClick,
    onSetStoreClick,
    productItem,
    renderAddToCartBtn
  } = props;

  const { openModal } = useModal();

  return (
    <div className={className} styleName="container">
      <Button
        onClick={() => {
          openModal(MODAL_TYPES.CHECK_INVENTORY, {
            hideCartItems,
            initialQuantity,
            initialRearQuantity,
            onSetStoreClick,
            productItem,
            renderAddToCartBtn
          });
          onCheckInventoryClick?.();
        }}
        size="regular"
      >
        available now nearby
      </Button>
    </div>
  );
}

CheckInventoryButton.propTypes = {
  className: PropTypes.string,
  hideCartItems: PropTypes.bool,
  initialQuantity: PropTypes.number,
  initialRearQuantity: PropTypes.number,
  onCheckInventoryClick: PropTypes.func,
  onSetStoreClick: PropTypes.func,
  productItem: PropTypes.object,
  renderAddToCartBtn: PropTypes.func
};

export default CheckInventoryButton;
